import type { Web3Library } from '../wallet/walletContext'
import { findRecentRouterTransactionHash } from '../wallet/findRecentRouterTransactionHash'
import {
  patchMobileLiquiditySession,
  readMobileLiquiditySession,
  type MobileLiquiditySession,
} from './mobileLiquiditySession'

export async function recoverMobileLiquiditySessionHash(
  library: Web3Library,
  account: string,
  chainId: number,
): Promise<MobileLiquiditySession | null> {
  const session = readMobileLiquiditySession()
  if (!session) return null
  if (session.hash) return session
  if (session.account.toLowerCase() !== account.toLowerCase()) return null
  if (session.chainId !== chainId) return null
  if (session.phase !== 'wallet' && session.phase !== 'submitted') return null

  const hash = await findRecentRouterTransactionHash(library, account, session.updatedAt)
  if (!hash) return session

  return patchMobileLiquiditySession({ hash, phase: 'submitted' }) ?? session
}
